import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table } from "react-bootstrap";
import { Col, Row, Tab, Nav } from 'react-bootstrap';
import { Link,useNavigate } from "react-router-dom";

const ExpensesTable = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [startMonth, setStartMonth] = useState('');
  const [endMonth, setEndMonth] = useState('');
  const [year, setYear] = useState('');

  const arabicMonthNames = [
    "يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
    "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
  ];

  const navigate = useNavigate();

//================================================================
const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
const userPermissions = JSON.parse(userPermissionsJSON);
function getActionsForPage(pageName) {
  const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
console.log('actionsForPage',pagePermissions); 
 if (pagePermissions) {
     return pagePermissions.action;
 } else {
navigate('/dashboard_1')
    return [];
 }
}
const pageName = 'CompanyExpenses';
const actionsForPage = getActionsForPage(pageName);

//=============================================================================================
  useEffect(() => {
    fetchExpenses();
  }, []);
   const fetchExpenses = async () => {
    try {
      const response = await axios.get("https://subk.education.com.ly/back/api/getMonthlyExpenses");
      setData(response.data);
      setFilteredData(response.data); // Initially, no filters applied
    } catch (error) {
      console.error("Error fetching expenses:", error);
    }
  };

  const calculateNet = (row) => {
    return row.income - row.employee_expenses - row.purchases - row.rent;
  };

  const handleFilter = () => {
    const start = parseInt(startMonth, 10) || 1;
    const end = parseInt(endMonth, 10) || 12;
    
    const filtered = data.filter((row) => {
      const rowDate = new Date(row.date);
      const rowMonth = rowDate.getMonth() + 1; // Get the month (1-12)
      const rowYear = rowDate.getFullYear();

      const isMonthMatch = rowMonth >= start && rowMonth <= end;
      const isYearMatch = year ? rowYear === parseInt(year, 10) : true;

      return isMonthMatch && isYearMatch;
    });

    setFilteredData(filtered);
    calculateTotalNetIncome()
    calculateTotalIncome() 
  };

  const handleClearFilters = () => {
    setStartMonth('');
    setEndMonth('');
    setYear('');
    setFilteredData(data); // Reset filters and show all data
    calculateTotalNetIncome()
        calculateTotalIncome()
  };

  // Calculate total income and total net income
  const calculateTotalIncome = () => {
    return filteredData.reduce((sum, row) => sum + (parseFloat(row.income) || 0), 0);
  };
  

  const calculateTotalNetIncome = () => {
    return filteredData.reduce((sum, row) => sum + calculateNet(row), 0);
  };

  return (
    <div className='container-fluid'>
    <Row>
        <Col lg="12">
            <div className="card px-4">
                <div className="card-body p-0">
                    <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">

                        <div className="tbl-caption">
                            <h4 className="heading ms-3">دخل الشركة</h4>
                        </div>       

      {/* Filter Section */}
      {actionsForPage.includes('export') && (
  <div className="row mb-3">
    <div className="col-md-3" style={{ display: 'flex' }}>
      <label htmlFor="startMonth" className="form-label ms-2 mt-1">من</label>
      <select
        className="default-select form-control"
        id="startMonth"
        value={startMonth}
        onChange={e => setStartMonth(e.target.value)}
      >
        <option value="">اختر</option>
        {arabicMonthNames.map((month, index) => (
          <option key={index} value={index + 1}>{month}</option>
        ))}
      </select>
    </div>
    <div className="col-md-3" style={{ display: 'flex' }}>
      <label htmlFor="endMonth" className="form-label ms-2 mt-1">إلى</label>
      <select
        className="default-select form-control"
        id="endMonth"
        value={endMonth}
        onChange={e => setEndMonth(e.target.value)}
      >
        <option value="">اختر</option>
        {arabicMonthNames.map((month, index) => (
          <option key={index} value={index + 1}>{month}</option>
        ))}
      </select>
    </div>
    <div className="col-md-3" style={{ display: 'flex' }}>
      <label htmlFor="year" className="form-label ms-2 mt-1">السنة</label>
      <input
        className="form-control"
        type="text"
        value={year}
        placeholder="اختر السنة"
        onChange={e => setYear(e.target.value)}
      />
    </div>
    <div className="col-md-3">
      <button className="btn btn-primary btn-sm me-1" onClick={handleFilter}>ابحث</button>
      <button className="btn btn-secondary btn-sm me-1" onClick={handleClearFilters}>إلغاء</button>
    </div>
  </div>
)}
      {actionsForPage.includes('export') && (

<div className="row mb-3" style={{ display: 'flex' }}>
  <div className="col-md-4" style={{ display: 'flex' }}>
    <label htmlFor="totalIncome" style={{ fontSize: '15px', fontWeight: 'bold' }}>إجمالي الدخل:</label>
    <div style={{ color: 'blue', marginLeft: '10px' }}>
      <strong>{calculateTotalIncome()}</strong>
    </div>
  </div>
  <div className="col-md-4" style={{ display: 'flex' }}>
    <label htmlFor="totalNetIncome" style={{ fontSize: '15px', fontWeight: 'bold' }}>صافي الدخل:</label>
    <div style={{ color: 'green', marginLeft: '10px' }}>
      <strong>{calculateTotalNetIncome()}</strong>
    </div>
  </div>
</div>)}
{actionsForPage.includes('export') && (

<Table responsive striped bordered className="verticle-middle">
   <thead style={{ position: "sticky", top: 0,  zIndex: 1 }}>                      

    <tr>
      <th>الشهر</th>
      <th>الدخل</th>
      <th>مصاريف الموظف</th>
      <th>المشتريات</th>
      <th>الإيجار</th>
      <th>مصاريف استهلاكية</th>
      <th>صافي الدخل</th>
    </tr>
  </thead>
  <tbody>
    {filteredData.map((row, index) => (
      <tr key={index}>
        <td>{row.date}</td>
        <td>{row.income}</td>
        <td>{row.employee_expenses}</td>
        <td>{row.purchases}</td>
        <td>{row.rent}</td>
        <td>{row.consumption_expenses}</td>
        <td>{calculateNet(row)}</td>
      </tr>
    ))}
  </tbody>
</Table>
)}
      </div>
                        </div> </div> 

                </Col>
            </Row>
        </div>    
  );
};

export default ExpensesTable;
